/**
 * Applique l'import CKA sur les stores locaux (idempotent, aucun compte de connexion).
 * Les lignes officielles sont chargées à la demande (pas dans le bundle de chaque écran).
 */
import { getDataStore, mergeCollection, updateItem } from "@/data/dataStore.js";
import {
  getMembershipStore,
  replaceCkaImportedMemberships,
} from "@/membership/membershipStore.js";
import { applyCkaImportPlan, planCkaImport } from "./ckaImportEngine.js";
import { CKA_IMPORT_SOURCE } from "./ckaImportConstants.js";

let lastPlan = null;

export function getLastCkaImportPlan() {
  return lastPlan;
}

async function resolveRows(sourceRows) {
  if (sourceRows) return sourceRows;
  const mod = await import("./ckaOfficialSourceRows.js");
  return mod.CKA_OFFICIAL_SOURCE_ROWS;
}

export async function dryRunCkaOfficialImport(sourceRows) {
  const rows = await resolveRows(sourceRows);
  const data = getDataStore();
  const membership = getMembershipStore();
  lastPlan = planCkaImport(rows, {
    etudiants: data.etudiants,
    instructeurs: data.instructeurs,
    dojos: data.dojos,
    memberships: membership.memberships,
  });
  return lastPlan;
}

export async function applyCkaOfficialImport(sourceRows) {
  const plan = await dryRunCkaOfficialImport(sourceRows);
  const data = getDataStore();
  const membership = getMembershipStore();
  const next = applyCkaImportPlan(plan, {
    etudiants: data.etudiants,
    instructeurs: data.instructeurs,
    dojos: data.dojos,
    memberships: membership.memberships,
  });
  mergeCollection("dojos", next.dojos);
  mergeCollection("instructeurs", next.instructeurs);
  mergeCollection("etudiants", next.etudiants);
  try {
    updateItem("instructeurs", "inst-gilles-lavigne", {
      titre: "Hanshi",
      organisation: "Shotokan",
      nom: "Gilles Lavigne",
    });
  } catch {
    /* already merged */
  }
  const imported = next.memberships.filter((m) => m.origin === CKA_IMPORT_SOURCE);
  replaceCkaImportedMemberships(imported);
  return { plan, applied: true };
}

export function listOfficialImportedStudents() {
  return (getDataStore().etudiants || []).filter((s) => s.source === CKA_IMPORT_SOURCE || s.id?.startsWith("cka-etud-"));
}
